(function ($, Drupal) {
  // Header behaviors (Sticky, scroll direction...)
  Drupal.behaviors.initVideo = {
    attach(context, settings) {
      $('.lifestyle--D', context).once('initVideo').each(function () {
        const $el = $(this),
          $wrap = $el.find('.lifestyle__text'),
          $iframe = $wrap.find('iframe');

        function calculateRatio() {
          const $width = $iframe.width(),
            $height = $iframe.height(),
            $paddingFactor = ($height / $width) * 100;

          $wrap.css('padding-top', `${$paddingFactor}%`).addClass('videowrap');
        }

        $iframe.ready(calculateRatio());
      });
    },
  };
}(jQuery, Drupal));
